<template>
    <div class="app-layout">
        <div class="app-view">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
        <NavTab/>
    </div>
</template>

<script>
// import { getHome } from '@/api';
import NavTab from './components/NavTab.vue';

export default {
  name: 'Layout',
  components: { NavTab },
  data() {
    return {

    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      // const res = await getHome();
      // console.log('getHome res------', res);
    },
  },

};
</script>

<style lang="less">
.app-layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    .app-view {
        flex: 1;
        overflow-y: scroll;
    }
}
</style>
